/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'agent/admiral': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M15.727 13.064l-.029-.029V9.364l-.436.289V12.6L10.09 7.428l-5.256 5.257V9.714l-.436-.286v5.824L10.049 19l5.648-3.749v-.419l.029-.029-.029-.03v-1.677l.03-.032zm-5.678 5.413l-5.02-3.329 5.061-5.061 5.029 5.027-5.07 3.363zm5.213-4.14L10.09 9.166l-5.256 5.257v-.876l.029.029L10.09 8.35l5.172 5.171v.816z"/><path pid="1" d="M10.066 6.663l3.612 3.55 5.092-3.334h-6.956L9.992 1 8.334 6.879H1.23l5.176 3.38z"/><path pid="2" d="M4.834 4.706h3.668l.121-.434H4.398v2.173h.436zm10.428 0v1.739h.435V4.272h-4.252l.143.434z"/>'
  }
})
